export enum EnterpriseType {
  Private = "private",
  Legal = "legal",
}
